import React, { useState, useEffect } from "react";
import CardSeplag from "../../../components/CardSeplag";
import CardExibirPdf from "../../../components/CardExibirPDF";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import download from "downloadjs";

import {
  carregarArvoreMonitora,
  carregarArvoreMonitoraComFiltro,
  buscarAcao,
  buscarExercicio,
  buscaProduto,
  buscarSubAcao,
  buscaCiclo,
  buscarOrgaos,
  gerarRelatorioBaseGeral,
} from "../../../service/ArvoreMonitora";

const RelatorioBaseGeral = () => {
  const OpcoesPrioritario = [
    {
      name: "TODOS",
      code: undefined,
    },
    {
      name: "NÃO",
      code: "N",
    },
    {
      name: "SIM",
      code: "S",
    },
  ];

  const TipoRelatorio = [
    { name: "PDF", code: "P" },

    { name: "EXCEL", code: "E" },
  ];

  const [visible, setVisible] = useState(false);
  const [ptaMonitoraSelecionado, setPtaMonitoraSelecionado] = useState();

  const [cDadosArvore, setCDadosArvore] = useState([]);
  const [cDadosExercicios, setCDadosExercicios] = useState([]);
  const [cDadosCiclo, setCDadosCiclo] = useState([]);
  const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
  const [cDadosUOs, setCDadosUOs] = useState([]);
  const [cDadosProgramas, setCDadosProgramas] = useState([]);
  const [cDadosAcoes, setCDadosAcoes] = useState([]);
  const [cDadosProdutoAcoes, setCDadosProdutoAcoes] = useState([]);
  const [cDadosSubAcoes, setCDadosSubAcoes] = useState([]);
  const [cDadosItemPrioritario, setCDadosItemPrioritario] = useState([]);
  const [cDadosTipoRelatorio, setCDadosTipoRelatorio] = useState([]);

  const [exercicioSelecionado, setExercicioSelecionado] = useState([]);
  const [cicloSelecionado, setCicloSelecionado] = useState([]);
  const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
  const [uoSelecionada, setUoSelecionada] = useState([]);
  const [programaSelecionado, setProgramaSelecionado] = useState([]);
  const [acaoSelecionada, setAcaoSelecionada] = useState([]);
  const [produtoAcaoSelecionada, setProdutoAcaoSelecionada] = useState([]);
  const [subAcaoSelecionada, setSubAcaoSelecionada] = useState([]);
  const [itemPrioritarioSelecionado, setItemPrioritarioSelecionado] = useState([]);
  const [tipoRelatorioSelecionado, setTipoRelatorioSelecionado] = useState([]);

  const [tituloPDF, setTituloPDF] = useState("");
  const [dadosRelatorioBase64, setDadosRelatorioBase64] = useState(null);
  const [isExibirPDF, setIsExibirPDF] = useState(false);

  const [exibirRelatorio, setExibirRelatorio] = useState(false);

  useEffect(() => {
    setCDadosExercicios([]);
    buscarExercicio().then((res) => {
      setCDadosExercicios(res.data.listaExercicios);
    });
  }, []);

  function montarArvore(dadosArvore) {
    if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
      setCDadosArvore(dadosArvore.arvorePtaMonitoras);
    } else {
      setCDadosArvore({ content: { key: null, statusItem: null, tipoItemPta: null } });
    }
    setCDadosExercicios(dadosArvore != null ? dadosArvore.listaExercicios : null);
    setCDadosCiclo(
      dadosArvore && dadosArvore.parametroExercicio
        ? dadosArvore.parametroExercicio
        : { cicloMonitoramento: { statusCiclo: "" } }
    );
    setCDadosOrgaos(dadosArvore != null ? dadosArvore.orgaoFiplans : null);
    setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
    setCDadosProgramas(dadosArvore != null ? dadosArvore.programas : null);
    setCDadosItemPrioritario(dadosArvore != null ? dadosArvore.opcoesPrioritario : null);
    setCDadosTipoRelatorio(dadosArvore != null ? dadosArvore.tipoRelatorio : null);
  }

  let defaultArvoreMonitora = {
    arvorePtaMonitoras: cDadosArvore,
    listaExercicios: cDadosExercicios,
    parametroExercicio: cDadosCiclo,
    orgaoFiplans: cDadosOrgaos,
    unidadeOrcamentarias: cDadosUOs,
    programas: cDadosProgramas,
    acao: cDadosAcoes,
    produto: cDadosProdutoAcoes,
    subAcao: cDadosSubAcoes,
    ciclo: cDadosCiclo,
  };

  const [filtro, setFiltro] = useState(false);

  const onChangeExercicio = (e) => {
    setExercicioSelecionado(e.value);
    setOrgaoSelecionado(null);
    setCDadosUOs([]);
    setUoSelecionada(null);
    setCDadosProgramas([]);
    setProgramaSelecionado(null);
    setCDadosAcoes([]);
    setAcaoSelecionada(null);
    setCDadosProdutoAcoes([]);
    setProdutoAcaoSelecionada(null);
    setCDadosSubAcoes([]);
    setSubAcaoSelecionada(null);

    buscaCiclo(e.value.idenExercicio).then((retorno) => {
      setCDadosCiclo(retorno.data);
      buscarOrgaos(e.value.idenExercicio).then((res) => {
        setCDadosOrgaos(res.data);
      });
    });

    //setCDadosOrgaos(null)

    /*setCDadosArvore(montarArvore(null))
        let filtro = {
          idenExercicio: e.value.idenExercicio,
          idenOrgao: null,
          idenUo : null,
          idenPrograma : null
        }
        carregarArvoreMonitoraComFiltro(filtro,defaultArvoreMonitora).then((res) => {
          montarArvore(res)
        })*/
  };

  const onChangeOrgao = (e) => {
    setOrgaoSelecionado(e.value);
    setUoSelecionada(null);
    setProgramaSelecionado(null);
    setCDadosUOs(null);
    setCDadosProgramas(null);
    setCDadosArvore(null);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: e.value.idenOrgao,
      idenUo: null,
      idenPrograma: null,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
    });
  };
  const onChangeUo = (e) => {
    setUoSelecionada(e.value);
    setProgramaSelecionado(null);
    setCDadosProgramas(null);
    setCDadosArvore(null);
    let filtro = {
      idenExercicio: exercicioSelecionado.idenExercicio,
      idenOrgao: orgaoSelecionado.idenOrgao,
      idenUo: e.value.idenUo,
      idenPrograma: null,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
      setCDadosCiclo(res.parametroExercicio);
      setCDadosOrgaos(res.orgaoFiplans);
      setCDadosUOs(res.unidadeOrcamentarias);
      setCDadosProgramas(res.programas);
    });
  };

  const onChangePrograma = (e) => {
    setProgramaSelecionado(e.value);
    let listaPrograma = [e.value.idenPrograma];
    let listaUnidOrcamentaria = [uoSelecionada.idenUo];
    let JsonBody = {
      listaPrograma,
      listaUnidOrcamentaria,
    };
    buscarAcao(JsonBody).then((res) => {
      setCDadosAcoes(res.data);
      setAcaoSelecionada(null);
      setCDadosProdutoAcoes([]);
      setProdutoAcaoSelecionada(null);
      setSubAcaoSelecionada(null);
    });
  };

  const onChangeAcao = (e) => {
    setAcaoSelecionada(e.value);
    let idenPtaMonitora = e.value.key;
    buscaProduto(idenPtaMonitora).then((retorno) => {
      setCDadosProdutoAcoes(retorno.data);
      setProdutoAcaoSelecionada(null);
      setCDadosSubAcoes([]);
      setSubAcaoSelecionada(null);
    });
  };

  const onChangeProdutoAcao = (e) => {
    setProdutoAcaoSelecionada(e.value);
    let idenPtaMonitora = e.value.key;
    buscarSubAcao(idenPtaMonitora).then((retorno) => {
      setCDadosSubAcoes(retorno.data);
      setSubAcaoSelecionada(null);
    });
  };

  const onChangeSubAcao = (e) => {
    setSubAcaoSelecionada(e.value);
  };

  const onChangeItemPrioritario = (e) => {
    setItemPrioritarioSelecionado(e.value);
  };

  const onChangeTipoRelatorio = (e) => {
    setTipoRelatorioSelecionado(e.value);
  };

  const gerarRelatorio = () => {
    let idenExercicio =
      exercicioSelecionado && exercicioSelecionado != null ? exercicioSelecionado.idenExercicio : null;
    let idenCiclo = cicloSelecionado && cicloSelecionado != null ? cicloSelecionado.idenCiclo : null;
    let idenOrgao = orgaoSelecionado && orgaoSelecionado != null ? orgaoSelecionado.idenOrgao : null;
    let listaUo = uoSelecionada && uoSelecionada != null ? [uoSelecionada.idenUo] : [];
    let listaPrograma = programaSelecionado && programaSelecionado != null ? [programaSelecionado.idenPrograma] : [];
    // let listaAcao       = acaoSelecionada && acaoSelecionada != null ?  [acaoSelecionada.idenPtaFiplan] : []
    // let listaProduto    = produtoAcaoSelecionada && produtoAcaoSelecionada != null ? [produtoAcaoSelecionada.idenPtaFiplan] : []
    // let listaSubAcao    = subAcaoSelecionada && subAcaoSelecionada != null ? [subAcaoSelecionada.idenPtaFiplan] : []
    let flagPrioritario =
      itemPrioritarioSelecionado && itemPrioritarioSelecionado != null ? itemPrioritarioSelecionado.code : null;
    let tipoRelatorio = "E";
    let JsonBody = {
      idenExercicio,
      idenCiclo,
      idenOrgao,
      listaUo,
      listaPrograma,
      // listaAcao,
      // listaProduto,
      // listaSubAcao,
      flagPrioritario,
      tipoRelatorio,
    };

    gerarRelatorioBaseGeral(JsonBody).then((res) => {
      download(
        `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`,
        `${res.data.nomeArquivo}`,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
    });
  };
  function fecharJanela() {
    setExibirRelatorio(false);
    setIsExibirPDF(false);
  }

  return (
    <CardSeplag title="MONITORAMENTO : RELATÓRIO DE BASE GERAL">
      <div className="p-fluid grid line-height-4">
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selExercicio">Exercício</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selExercicio"
                  value={exercicioSelecionado}
                  options={cDadosExercicios}
                  onChange={onChangeExercicio}
                  optionLabel="ano"
                  filter
                  filterBy="ano"
                  placeholder="Selecione um exercício"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selCiclo">Ciclo</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selCiclo"
                  value={cicloSelecionado}
                  options={cDadosCiclo}
                  onChange={(e) => {
                    setCicloSelecionado(e.value);
                  }}
                  optionLabel="descCiclo"
                  filter
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Ciclo"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selOrgao">Órgão</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selOrgao"
                  value={orgaoSelecionado}
                  options={cDadosOrgaos}
                  onChange={onChangeOrgao}
                  optionLabel="descricaoFiplan"
                  filter
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Órgão"
                />
              </span>
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selUO">U.O.</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selUO"
                  value={uoSelecionada}
                  options={cDadosUOs}
                  onChange={onChangeUo}
                  optionLabel="descricaoFiplan"
                  filter
                  filterBy="descricaoFiplan"
                  placeholder="Selecione uma U.O."
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selPrograma">Programa</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selPrograma"
                  value={programaSelecionado}
                  options={cDadosProgramas}
                  onChange={onChangePrograma}
                  optionLabel="descricaoFiplan"
                  filter
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Programa"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selPrio">Item Prioritário</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selItemPrioritario"
                  value={itemPrioritarioSelecionado}
                  options={OpcoesPrioritario}
                  onChange={onChangeItemPrioritario}
                  optionLabel="name"
                  filter
                  filterBy="true"
                  placeholder="Selecione um Item Prioritário"
                />
              </span>
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 "></div>
            <div className="field col-12 md:col-4"></div>
            <div className="field col-12 md:col-4"></div>
            <div className="field col-12 md:col-4"></div>
          </div>
        </div>
      </div>
      <div className="col-12 md:col-1">
        <Button type="button" label="Gerar" icon="pi pi-file" className="col-3 col-12" onClick={gerarRelatorio} />

        {isExibirPDF && (
          <CardExibirPdf
            tamanhoTela="50.vw"
            alturaTela="360.vh"
            stringPDF={"data:application/pdf;base64," + dadosRelatorioBase64}
            tituloTela={tituloPDF}
            isExibirPDF={isExibirPDF}
            position="center"
            onHide={fecharJanela}
          />
        )}
      </div>
    </CardSeplag>
  );
};

export default RelatorioBaseGeral;
